/*
 * Notice: This software is proprietary to Pocketbook, its affiliates, partners and/or
 * licensors. Unauthorized copying, distribution or use is strictly prohibited.
 * All rights reserved.
 */

'use strict';

angular.module('webReader')
    .directive('navTabsBuilder', function() {
        return {
            scope: {
                tabsInfoCollection: "="
            },
            restrict: 'E',
            replace: true,
            templateUrl: 'directives/nav-tabs-builder/nav-tabs-builder.view.html',
            controller: ["$scope", "LocalizationService", "$sce", "$compile", function($scope, LocalizationService, $sce, $compile) {
                var scope = $scope;
                scope.loaded = false;
                scope.tabsCollection = [];
                scope.params = [];
                scope.outputHtml = '<tabset>';
                // LocalizationService.create();

                LocalizationService.subscribe.onLocalizationLoaded(function() {
                    _.each(scope.tabsInfoCollection, function(el, i) {
                        scope.params.push(el.params);
                        scope.outputHtml += '<tab heading="' + LocalizationService.getTranslation(el.heading) + '">' + el.content + '</tab>';
                    });

                    scope.outputHtml += '</tabset>';
                    $('#nav-tabs').append($compile(scope.outputHtml)(scope));
                    scope.loaded = true;
                });

            }]
        };
    });